import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* addLookbookUsers({ payload: { id, values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.lookbooks.addUser, id, data: values });

    onSuccess && onSuccess();
    yield put(actions.addLookbookUsersDone(data.result));
  } catch (error) {
    onError && onError(error);
    yield handleErrors({
      error,
      putErrorData: actions.addLookbookUsersFailed,
      handledErrors,
      endpoint: api.lookbooks.addUser.url
    });
  }
}

export const addLookbookUsersSaga = takeEvery(types.ADD_LOOKBOOK_USERS_REQUEST, addLookbookUsers);